import React from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, ChipGroup, makeStyles, SearchSelect } from "../../..";
import countries from "../../../assets/countries";
import languages from "../../../assets/languages";
import currencies from "../../../assets/currencies";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "no-wrap",
      padding: "20px"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    service: {
      width: "100%"
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    repeatField: {
      width: "50%",
      "margin-right": "20px"
    },
    flex: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  };
});

var FranchiseForm = function FranchiseForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "name",
    className: classes.mr30,
    label: "Franchise",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view",
    value: values.name
  }), /*#__PURE__*/React.createElement(Field, {
    name: "currency",
    className: classes.mr30,
    component: SearchSelect,
    options: currencies,
    placeholder: "Select a currency",
    value: values.currency,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "country",
    value: values.country,
    className: classes.mr30,
    placeholder: "Select a country",
    component: SearchSelect,
    options: countries,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "language",
    value: values.language,
    className: classes.mr30,
    placeholder: "Select a language",
    component: SearchSelect,
    options: languages,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "vendor_id",
    className: classes.mr30,
    label: "Marketplace Vendor ID",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view",
    value: values.vendor_id
  }), /*#__PURE__*/React.createElement(Field, {
    name: "oldManagerId",
    className: classes.mr30,
    label: "Old Manager ID",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view",
    value: values.oldManagerId
  })));
};

FranchiseForm.defaultProps = {
  mode: "add"
};
export { FranchiseForm };